export default __webpack_public_path__ + "e38ac99f.png";